import React from 'react';
export function WhatIsValuan() {
  return <section className="py-20 px-6 max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-12" data-id="element-225">
      {/* Style 6 (black) + Style 5 (blue bold) */}
      <h2 className="flex-1 text-center md:text-left" data-id="element-226">
        <span className="text-section-heading" data-id="element-227">¿Qué es </span>
        <span className="text-section-heading-blue" data-id="element-228">valuan</span>
        <span className="text-section-heading" data-id="element-229">?</span>
      </h2>
      {/* Style 1 — body text */}
      <div className="flex-1 text-body text-center md:text-left" data-id="element-230">
        <p data-id="element-231">
          Valuan es un ecosistema digital diseñado para{' '}
          <span className="text-subheading-blue !text-[20px] !leading-[28px]" data-id="element-232">
            automatizar tu éxito
          </span>
          . Sustituye herramientas aisladas por un flujo de trabajo conectado,
          escalable y 100% centrado en el cliente.
        </p>
      </div>
    </section>;
}